import React, { useRef } from "react";

import IntervalButton from "./IntervalButton";
import { Wrapper } from "./styles";
import { getIntervalKnowledge } from "./utils";
import { IProps } from "./interfaces";

const IntervalsLadder = ({ score, frameScale, handleInput }: IProps) => {
    const intervalKnowledge = useRef(getIntervalKnowledge(score)).current;
    return (
        <Wrapper>
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[1]}
                scale={frameScale}
                num={1}
                x={1.5}
                hasLocal
                up={intervalKnowledge[1] && intervalKnowledge[1].up ? [1] : undefined}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[2]}
                scale={frameScale}
                num={2}
                x={3}
                down={[0.5, ...(intervalKnowledge[2] && intervalKnowledge[2].down ? [1.5] : [])]}
                up={[0.5, ...(intervalKnowledge[2] && intervalKnowledge[2].up ? [1.5] : [])]}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[3]}
                scale={frameScale}
                num={3}
                x={5}
                down={[0.5, ...(intervalKnowledge[3] && intervalKnowledge[3].down ? [1.5] : [])]}
                up={[0.5, ...(intervalKnowledge[3] && intervalKnowledge[3].up ? [1.5] : [])]}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[4]}
                scale={frameScale}
                num={4}
                x={6.5}
                up={[1]}
                down={intervalKnowledge[4] && intervalKnowledge[4].down ? [1] : undefined}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[5]}
                scale={frameScale}
                num={5}
                x={8.5}
                down={[1]}
                up={intervalKnowledge[5] && intervalKnowledge[5].up ? [1] : undefined}

            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[6]}
                scale={frameScale}
                num={6}
                x={10}
                down={[0.5, ...(intervalKnowledge[6] && intervalKnowledge[6].down ? [1.5] : [])]}
                up={[0.5, ...(intervalKnowledge[6] && intervalKnowledge[6].up ? [1.5] : [])]}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[7]}
                scale={frameScale}
                num={7}
                x={12}
                down={[0.5, ...(intervalKnowledge[7] && intervalKnowledge[7].down ? [1.5] : [])]}
                up={[0.5, ...(intervalKnowledge[7] && intervalKnowledge[7].up ? [1.5] : [])]}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[8]}
                scale={frameScale}
                num={8}
                x={13.5}
                hasLocal
                down={intervalKnowledge[8] && intervalKnowledge[8].down ? [1] : undefined}
                up={intervalKnowledge[8] && intervalKnowledge[8].up ? [1] : undefined}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[9]}
                scale={frameScale}
                num={9}
                x={15}
                down={[0.5, ...(intervalKnowledge[9] && intervalKnowledge[9].down ? [1.5] : [])]}
                up={[0.5, ...(intervalKnowledge[9] && intervalKnowledge[9].up ? [1.5] : [])]}
            />
            <IntervalButton
                handleInput={handleInput}
                isSeed={!intervalKnowledge[10]}
                scale={frameScale}
                num={10}
                x={17}
                down={[0.5, ...(intervalKnowledge[10] && intervalKnowledge[10].down ? [1.5] : [])]}
                up={[0.5, ...(intervalKnowledge[10] && intervalKnowledge[10].up ? [1.5] : [])]}
            />
        </Wrapper>
    );
}

export default IntervalsLadder;
